<div class="dx-field-value">
  <!-- <dx-switch [(value)]="valueBoolean" [switchedOffText]="switchedOffText" [switchedOnText]="switchedOnText"
          [disabled]="disabled" [readOnly]="readonly()"
        (valueChange)="onValueChange($event)" [width]="dxWidth"></dx-switch> -->
        <mat-slide-toggle  class="example-margin"
        [color]="color"
        [checked]="checked"
        [disabled]="disabled()">
        {{switchedOnText()}}</mat-slide-toggle>

</div>
